<script>
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import Changes from "@wielink-application/shared/js/mixins/changes";
import {useForm} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";

export default {
  components: {Card},
  mixins: [FormElements, Changes],
  data() {
    return {
      options: [
        {value: 'mixture_l', label: 'Mengsel L'},
        {value: 'mixture_e', label: 'Mengsel E'},
        {value: 'mixture_f', label: 'Mengsel F'},
        {value: 'mixture_g', label: 'Mengsel G'},
        {value: 'kvalues_calfilter1', label: 'Cal. Filter1'},
        {value: 'kvalues_calfilter2', label: 'Cal. Filter2'},
        {value: 'kvalues_calfilter3', label: 'Cal. Filter3'},
      ],
      cylinder: {},
      user: {},
      product_type: {},
      form: useForm({
        name: '',
        type: '',
        co: '',
        co2: '',
        ppm: '',
        o2: '',
        user_id: '',
        calibration_date: '',
        custom_value: '',
        product_type: '',
      })
    }
  },
  computed: {
    isCalFilter() {
      return ['kvalues_calfilter1', 'kvalues_calfilter2', 'kvalues_calfilter3'].includes(this.form.type);
    }
  },
  methods: {
    setCylinder(cylinder) {
      this.cylinder = cylinder;
      this.user = cylinder.user ?? {};
      this.product_type = cylinder.product_type ?? {}
      this.form.defaults(Helpers.prepareFormDefaults(cylinder));
      this.form.reset();
      this.form.isDirty = false;
    }
  }
}
</script>

<template>
  <div class="row g-4 mb-4">
    <div class="col-xl-6">
      <Card class="h-100">
        <h2 class="card-title">Algemeen</h2>

        <Input
            :form="form"
            v-model="form.name"
            name="name"
            :required="true"
            label="Nummer"
        />

        <Select
            :form="form"
            v-model="form.type"
            name="type"
            :required="true"
            label="Mengsel"
            placeholder="Mengsel"
            :options="options"
        />

        <Date
            v-model="form.calibration_date"
            :form="form"
            name="calibration_date"
            label="kalibratiedatum"
        />

        <Select
            v-if="$page.props.auth.permissions.includes('manage all cylinders')"
            groupClasses="mb-2"
            v-model="form.user_id"
            name="user_id"
            label="Werknemer"
            :form="form"
            placeholder="Werknemer"
            :ajaxUrl="route('api.v1.users.list')"
            :currentValueLabel="user.name"
        />

      </Card>
    </div>

    <div class="col-xl-6">
      <Card class="h-100">
        <h2 class="card-title">Algemeen</h2>

        <Input
            :form="form"
            v-model="form.co"
            name="co"
            label="CO (%)"
            type="number"
            step="0.01"
            v-if="!isCalFilter"
        />

        <Input
            :form="form"
            v-model="form.co2"
            name="co2"
            label="CO2 (%)"
            type="number"
            step="0.01"
            v-if="!isCalFilter"
        />

        <Input
            :form="form"
            v-model="form.ppm"
            name="ppm"
            label="Prop (ppm)"
            type="number"
            step="0.01"
            v-if="!isCalFilter"
        />

        <Input
            groupClasses="mb-0"
            :form="form"
            v-model="form.o2"
            name="o2"
            label="O2 (%)"
            type="number"
            step="0.01"
            v-if="!isCalFilter"
        />

        <Input
            :form="form"
            v-model="form.custom_value"
            groupClasses="mb-0"
            name="custom_value"
            label="Standaard waarde"
            step="0.01"
            type="number"
            v-if="isCalFilter"
        />
      </Card>
    </div>
  </div>

</template>